import dayjs, { Dayjs } from 'dayjs'
import { DaylightDateFormat } from '@/constants/DaylightDateFormat'

/**
 * Format a date for API start parameter (T00:00:00)
 * @param date - Date object or Dayjs instance
 * @returns ISO formatted string with time set to 00:00:00
 */
export const formatApiDateStart = (date: Date | Dayjs): string => {
  return dayjs(date).hour(0).minute(0).second(0).format(DaylightDateFormat.ISO_DATE_TIME_WITHOUT_TIMEZONE)
}

/**
 * Format a date for API end parameter (T23:59:59)
 * @param date - Date object or Dayjs instance
 * @returns ISO formatted string with time set to 23:59:59
 */
export const formatApiDateEnd = (date: Date | Dayjs): string => {
  return dayjs(date).hour(23).minute(59).second(59).format(DaylightDateFormat.ISO_DATE_TIME_WITHOUT_TIMEZONE)
}
